import { React, useState, useContext, useEffect, useRef } from 'react';
import {
  Button,
  Text,
  Flex,
  HStack,
  ButtonGroup,
  useToast,
  Box,
  Center,
  Spinner,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  useDisclosure,
  Grid,
  useMediaQuery,
  Heading,
  Image,
  VStack,
  Divider,
} from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import { useNavigate, useLocation } from 'react-router';
import { AccountContext } from '../AccountContext';
import TextField from '../TextField';
import SelectField from '../SelectField';
// import sendMessageSolicitante from './sendMessageSolicitante';
import { ReactComponent as Chip } from '../../images/card-chip.svg';
import { ReactComponent as CheckCircle } from '../../images/check-circle.svg';
import VindiSupportBubble from './VindiSupportBubble';
import Detalhes from '../../images/Pagamento/detalhesCartao.svg';
import validaCPF from 'components/Utils/Functions/validaCPF';
import { FaCreditCard, FaCircleExclamation } from 'react-icons/fa6';

import Cards from '../Perfil/Pagamento/Icons/Cards';
import { getAppTheme, userIsSubscriber } from '../Utils/theme';
import { api } from 'api/api';
import { GiPadlock } from 'react-icons/gi';

import Clube from '../../images/dashboard/estrelaAzul.svg';

const onlyNumbers = (str) => str.replace(/[^0-9]/g, '');
const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;
const REACT_APP_DEOVITA_RECIPIENT_ID =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_DEOVITA_RECIPIENT_ID_PROD
    : process.env.REACT_APP_DEOVITA_RECIPIENT_ID_TEST;

const VINDI_AFFILIATE_DEOVITA_ID = parseInt(
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_VINDI_AFFILIATE_DEOVITA_ID_PROD
    : process.env.REACT_APP_VINDI_AFFILIATE_DEOVITA_ID_TEST,
  10
) || null;

const CartaoGenerico = (selecionado) => {
  const valorParcelas = selecionado.valorParcelas;
  const valor_selecionado = selecionado.selecionado;
  const mdvPercent = selecionado.mdvPercent ?? 0;
  const mdvGerente = selecionado.mdvGerente ?? 0;
  const mdvDiretor = selecionado.mdvDiretor ?? 0;
  const permiteParcelamento = selecionado.permiteParcelamento;
  const parcelamentoMaximo = selecionado.parcelamentoMaximo;

  const [lg] = useMediaQuery('(min-width: 425px)');
  const navigate = useNavigate();
  const { state } = useLocation();

  const { navig_to, valor, parcelsActive, split, valor_telemedicina } = state;

  const voucher = state?.voucher?.voucher;
  const tipo_voucher = state?.voucher?.tipo;

  const fromCadastro = navig_to === '/cadastro/analise' ? true : false;
  const parcelas = Parcelas(fromCadastro === true ? valor_selecionado : valor);
  const arrayTextoParcelas = parcelas.map((parcela) => parcela.string);
  const toast = useToast();
  const { user, setUser } = useContext(AccountContext);
  const { id_contrato, titular, cpf } = user;
  const backgroundColor =
    titular === true && id_contrato === 0
      ? '#5AB2AE'
      : titular === false && id_contrato === 0
        ? '#5AB2AE'
        : titular === true && id_contrato > 0
          ? '#5AB2AE'
          : '#5AB2AE';
  const { cards } = user;
  const { onClose } = useDisclosure();

  let defaultCard;
  let defaulData = { cvv: '', name: '', cardNumber: '' };

  function Parcelas(valor_total) {
    let qtde_max_parcelas, valor_min_parcela;

    if (state.service === 'contract') {
      // valor_min_parcela = valorMinimoParcela ? parseFloat(valorMinimoParcela) : 80;
      qtde_max_parcelas = parcelamentoMaximo ? parcelamentoMaximo : 12;
    } else {
      valor_min_parcela = 50;
      qtde_max_parcelas = 12;

      let qtde_parcelas = parseInt(valor_total / valor_min_parcela);
      if (qtde_parcelas <= 0) qtde_parcelas = 1;
      if (qtde_parcelas > qtde_max_parcelas) qtde_parcelas = qtde_max_parcelas;

      let parcelas = [];
      for (var i = 1; i <= qtde_parcelas; i++) {
        let valor_parcela_string = (valor_total / i).toFixed(2);
        let valor_parcela_float = parseFloat(valor_parcela_string);
        let string_parcela = `${i}x R$${valor_parcela_string} (sem juros)`;
        let parcela = { id: i, val: valor_parcela_float, string: string_parcela.replace('.', ',') };
        parcelas.push(parcela);
      }

      return parcelas;
    }

    let qtde_parcelas = qtde_max_parcelas;
    let parcelas = [];

    for (var i = 1; i <= qtde_parcelas; i++) {
      let valor_parcela_string = (valor_total / i).toFixed(2);
      let valor_parcela_float = parseFloat(valor_parcela_string);
      let string_parcela = `${i}x R$${valor_parcela_string} (sem juros)`;
      let parcela = { id: i, val: valor_parcela_float, string: string_parcela.replace('.', ',') };
      parcelas.push(parcela);
    }

    return parcelas;
  }
  const arrayCards = cards?.length > 0 ? [...cards].sort((a, b) => (b.default === true ? 1 : 0) - (a.default === true ? 1 : 0)) : [];

  if (arrayCards.length > 0) {
    arrayCards.map((card, index) => {
      if (card.default) {
        defaultCard = index;
        defaulData = {
          vindiPaymentProfileId: card.cartao_hash,
          vindi_customer_id: card.vindi_user_id || null,
          name: card.holder_name,
          cardNumber: `${card.brand} final ${card.last_digits}`,
          expirationDate: card.expiration_date,
          cpf: card?.holder_document,
        };
      }
    });
  }

  const [data, setData] = useState(defaulData);
  const [loading, setLoading] = useState(false);
  const [enterCard, setEnterCard] = useState(false);
  const [aviso, setAviso] = useState(null);
  const [parcel, setParcel] = useState(state.service === 'contract' && state?.plano_anual === true ? '12' : '1');
  const [tipoCartao, setTipoCartao] = useState('credito');
  const [cartaoSelecionado, setCartaoSelecionado] = useState(null);
  const [paid, setPaid] = useState(false);
  const [awaitingWebhook, setAwaitingWebhook] = useState(false);
  const [webhookTransactionId, setWebhookTransactionId] = useState(null);
  const paidStateRef = useRef(null);
  const sseRef = useRef(null);

  function navigateCredit() {
    const tipo = state?.item?.[0]?.tipo;
    if (tipo === 'pediatra') {
      navigate('/aviso-pre-atendimento/', { replace: true, state: { titulo: 'Pronto Atendimento Pediátrico', tela: '/medico-agora/', pediatra: true } });
    } else if (tipo === 'veterinario') {
      navigate('/aviso-pre-atendimento/', { replace: true, state: { titulo: 'Telemedicina Pet', tela: '/telepet/termos/', pediatra: false } });
    } else {
      navigate('/aviso-pre-atendimento/', { replace: true, state: { titulo: 'Pronto Atendimento', tela: '/medico-agora/', pediatra: false } });
    }
  }

  function goNext() {
    if (state.service === 'credit') {
      navigateCredit();
      return;
    }
    navigate(navig_to, { replace: true, state: paidStateRef.current });
  }

  useEffect(() => {
    if (!paid) return;
    const timer = setTimeout(goNext, 2000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paid]);

  useEffect(() => {
    if (!awaitingWebhook || !webhookTransactionId) return;

    const es = new EventSource(`${ENDPOINT}/notifications/payment-sse?transaction_id=${webhookTransactionId}`);
    sseRef.current = es;

    es.addEventListener('payment_status', (e) => {
      try {
        const eventData = JSON.parse(e.data);
        if (eventData.status === 'paid') {
          es.close();
          setAwaitingWebhook(false);
          setPaid(true);
        } else if (eventData.status === 'refused') {
          es.close();
          setAwaitingWebhook(false);
          setAviso(eventData.reason || 'Pagamento recusado pelo banco.');
        }
      } catch {}
    });

    es.onerror = () => {};

    return () => {
      es.close();
      sseRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [awaitingWebhook, webhookTransactionId]);

  const HandleChange = (e) => {
    const { name, value } = e.target;
    setData((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  function callToast() {
    toast({
      title: 'Importante',
      description: 'Selecione ou cadastre um cartão para realizar o o pagamento',
      status: 'warning',
      duration: 4000,
      isClosable: true,
      position: 'top',
      colorScheme: 'red',
      containerStyle: {
        paddingTop: '50px',
      },
    });
  }

  async function pagar(vals) {
    if (vals.cardNumber === '') {
      callToast();
      setLoading(false);
      return;
    }
    const erroMsg = 'Não foi possível completar seu pagamento nesse momento.';

    const requestOptions = {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(vals),
    };

    api(`${ENDPOINT}/payment/${state.service}/card`, requestOptions)
      .catch((err) => {
        setLoading(false);
        navigate('/perfil/pagamento/erro-pagamento');
        setAviso(erroMsg);
        return;
      })
      .then((res) => {
        if (!res || !res.ok || res.status >= 400) {
          setLoading(false);
          setAviso(erroMsg);
          navigate('/perfil/pagamento/erro-pagamento');
          return;
        }
        return res.json();
      })
      .then((data) => {
        if (!data) return;
        if (data.sucess === false && data.message === 'Já existe um contrato para esse paciente') {
          navigate('/alerts/sucesso/cadastro_contrato/');
        }
        if (data.sucess) {
          setAviso(null);
          vals['transaction_id'] = data.id;
          vals['paid'] = true;
          paidStateRef.current = {
            ...vals,
            ...state,
            credito: data?.credito_id,
            metadataCoparticipacao: state?.metadataCoparticipacao,
          };
          if (state.service === 'contract' && user.loggedIn) {
            api(`${ENDPOINT}/auth/login`, { credentials: 'include' })
              .then((r) => (r?.ok ? r.json() : null))
              .then((freshData) => {
                if (freshData?.loggedIn) {
                  setUser((prev) => ({ ...prev, ...freshData, email: freshData.email ? freshData.email.toLowerCase() : null }));
                }
              })
              .catch(() => {});
          }
          setLoading(false);
          setPaid(true);
          return;
        } else {
          setLoading(false);
          setAviso(data?.gateway_message || erroMsg);
        }
      });
  }

  function handleClickCard(card) {
    setData({
      vindiPaymentProfileId: card.cartao_hash,
      vindi_customer_id: card.vindi_user_id || null,
      name: card.holder_name,
      cardNumber: `${card.brand} final ${card.last_digits}`,
      expirationDate: card.expiration_date,
    });
  }

  function SelectCard() {
    return (
      <SelectField
        name="cartoes"
        colorScheme="teal"
        variant="outline"
        onChange={(e) => {
          let lastIndex = arrayCards?.length === 1 ? 1 : arrayCards?.length - 1;
          if (lastIndex === parseInt(e) || arrayCards?.length === 1) {
            navigate('/perfil/editar-cartao', { state: { op: 'new', card: {} } });
          } else {
            handleClickCard(cards[e]);
          }
        }}
        //label="Cartões"
        placeholder="Selecione o cartão"
        options={arrayCards}
      />
    );
  }

  function SavedCards() {
    return (
      <>
        <Button
          color={backgroundColor}
          variant="ghost"
          isFullWidth
          justifyContent="center"
          onClick={() => {
            setData(defaulData);
            setEnterCard(true);
          }}
          borderRadius={'full'}
        >
          {arrayCards?.length < 2 ? 'Cadastrar cartão' : 'Usar outro cartão'}
        </Button>
      </>
    );
  }

  const formCreditCard = () => {
    return (
      <Box mt={4} display={'flex'} flexDirection={'column'} gap={4}>
        <TextField
          label={'Titular do cartão'}
          name="name"
          type="text"
          placeholder="Digite o nome impresso no cartão"
          onBlur={HandleChange}
          required
        />
        <TextField
          label={'Número do Cartão'}
          name="cardNumber"
          type="tel"
          placeholder="xxxx xxxx xxxx xxxx"
          mask="9999 9999 9999 9999"
          maskChar={null}
          onBlur={HandleChange}
          required
        />
        <Grid gridTemplateColumns={lg ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)'} gap={4}>
          <TextField
            label={'Data de validade'}
            name="expirationDate"
            placeholder="xx/xx"
            type="tel"
            mask="99/99"
            maskChar={null}
            onBlur={HandleChange}
            required
          />
          <TextField label={'CVV'} name="cvv" type="tel" placeholder="xxx" onBlur={HandleChange} required />
        </Grid>
        <TextField
          label={'CPF'}
          name="cpf"
          type="tel"
          placeholder="xxx.xxx.xxx-xx"
          mask="999.999.999-99"
          maskChar={null}
          onBlur={HandleChange}
          required
        />

        {/* <Box w={'full'}>
          <FormLabel>Seu cartão é de débito ou crédito?</FormLabel>
          <HStack spacing={8}>
            <Checkbox isChecked={tipoCartao === 'debito'} colorScheme="teal" onChange={() => setTipoCartao('debito')}>
              Débito
            </Checkbox>
            <Checkbox isChecked={tipoCartao === 'credito'} colorScheme="teal" onChange={() => setTipoCartao('credito')}>
              Crédito
            </Checkbox>
          </HStack>
        </Box> */}
      </Box>
    );
  };

  const validate = (values) => {
    if (!fromCadastro) {
      return {};
    }
    if (fromCadastro && user.loggedIn && cards?.length > 0) {
      return {};
    }

    const errors = {};

    if (!values.cardNumber) {
      errors.cardNumber = 'Campo obrigatório';
    }
    if (!values.cvv) {
      errors.cvv = 'Campo obrigatório';
    }
    if (!values.expirationDate) {
      errors.expirationDate = 'Campo obrigatório';
    }
    if (!values.name) {
      errors.name = 'Campo obrigatório';
    }

    if (!values.cpf?.trim()) {
      errors.cpf = 'Campo obrigatório';
    } else if (!validaCPF(onlyNumbers(values.cpf.trim()))) {
      errors.cpf = 'Número de CPF inválido';
    }

    return errors;
  };
  let usuarioAssinante = user.id_contrato && user.descricao_plano ? true : false;
  if (user.titular === false) usuarioAssinante = true;
  const themeApp = getAppTheme(userIsSubscriber(user));
  const planoNome = state.nome_plano ? state.nome_plano : user?.descricao_plano;

  const isConsulta = state.service === 'telemedicine_deovita' || state.service === 'telemedicine_deovita_pet' || state.service === 'credit';

  const podeOferecerAssinatura = !usuarioAssinante && isConsulta;

  const voucherConsulta = () => {
    if (voucher) {
      return (
        <>
          <HStack justify="space-between" mb={2}>
            <HStack spacing={2} align="center" justify="center">
              <Text fontSize="xs" color="#616161" fontWeight="semibold">
                Voucher {voucher.voucher}
              </Text>
            </HStack>
            {tipo_voucher !== 'Vendedor' && (
              <Text fontSize="xs" fontWeight="bold" color="#2A918A">
                - R$ {state.valorEconomizado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </Text>
            )}
          </HStack>
        </>
      );
    }
    return null;
  };

  const valor_original = state.service === 'contract' ? state.valor_original : isConsulta ? valor_telemedicina : valor_selecionado;

  let valor_original_formatado;
  if (typeof valor_original === 'string' && valor_original.includes('R$')) {
    valor_original_formatado = valor_original;
  } else {
    valor_original_formatado = Number(valor_original).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  }
  return (
    <>
      <Formik
        initialValues={{ cartoes: defaultCard, parcel: state.service === 'contract' && state.parcelsActive ? 11 : 0 }}
        validate={validate}
        onSubmit={(values) => {
          var val = {};
          const deovitaRest = 100 - mdvPercent - mdvDiretor - mdvGerente;
          let split_jj =
            voucher && VINDI_AFFILIATE_DEOVITA_ID && deovitaRest > 0
              ? { amount: deovitaRest, affiliate_id: VINDI_AFFILIATE_DEOVITA_ID, amount_type: 'percentage' }
              : null;

          if (user.loggedIn && cards?.length > 0) {
            val = {
              particular: !usuarioAssinante ? true : false,
              metadataCoparticipacao: state?.metadataCoparticipacao,
              settle_the_debt_payment_view: state?.settle_the_debt_payment_view,
              id_cliente: user.id_cliente_deovita ? user.id_cliente_deovita : state.client_id,
              cpf: user.cpf,
              tipo: state?.tipo ? state?.tipo : null,
              vindiPaymentProfileId: data.vindiPaymentProfileId,
              vindi_customer_id: data.vindi_customer_id || null,
              coparticipacao: user?.allowsTelemedicina?.paga_telemedicina ? user?.allowsTelemedicina?.paga_telemedicina : false,
              amount: (fromCadastro === true ? valor_selecionado * 100 : valor * 100).toFixed(2),
              // tipoCartao: tipoCartao,
              installments: parcel,
              forma_pgto: 'card',
              triagem: state?.triagem ? state?.triagem : false,
              paid: false,
              frequencia: state.frequencia,
              valorParcelas: valorParcelas,
              split_rules:
                tipo_voucher === 'Vendedor'
                  ? voucher
                    ? voucher.recipient_id_vindi_gerente
                      ? [
                          { amount: mdvGerente, affiliate_id: parseInt(voucher.recipient_id_vindi_gerente), amount_type: 'percentage' },
                          { amount: mdvDiretor, affiliate_id: parseInt(voucher.recipient_id_vindi_diretor), amount_type: 'percentage' },
                          { amount: mdvPercent, affiliate_id: parseInt(voucher.recipient_id_vindi), amount_type: 'percentage' },
                          ...(split_jj ? [split_jj] : []),
                        ]
                      : voucher.recipient_id_vindi_diretor
                        ? [
                            { amount: mdvDiretor, affiliate_id: parseInt(voucher.recipient_id_vindi_diretor), amount_type: 'percentage' },
                            { amount: mdvPercent, affiliate_id: parseInt(voucher.recipient_id_vindi), amount_type: 'percentage' },
                            ...(split_jj ? [split_jj] : []),
                          ]
                        : [
                            { amount: mdvPercent, affiliate_id: parseInt(voucher.recipient_id_vindi), amount_type: 'percentage' },
                            ...(split_jj ? [split_jj] : [{ amount: 100 - mdvPercent, affiliate_id: VINDI_AFFILIATE_DEOVITA_ID, amount_type: 'percentage' }]),
                          ]
                    : split
                  : split,
              item: fromCadastro
                ? {
                    client_id: state.client_id,
                    nome: state.name,
                    fone: user.phone1 ? user.phone1 : state.phone,
                    adicionais: state.adicionais,
                    plano: state.id_plano,
                  }
                : state.item,
              voucher: tipo_voucher === 'Vendedor' ? voucher : null,
              otherVoucher: tipo_voucher === 'Vendedor' ? null : voucher,
            };
          } else {
            val = {
              particular: !usuarioAssinante ? true : false,
              coparticipacao: user?.allowsTelemedicina?.paga_telemedicina ? user?.allowsTelemedicina?.paga_telemedicina : false,
              metadataCoparticipacao: state?.metadataCoparticipacao,
              settle_the_debt_payment_view: state?.settle_the_debt_payment_view,
              id_cliente: user.id_cliente_deovita ? user.id_cliente_deovita : state.client_id,
              cpf: user.cpf,
              tipo: state?.tipo ? state?.tipo : null,
              cardNumber: typeof values.cardNumber === 'string' ? onlyNumbers(values.cardNumber) : '',
              cvv: values.cvv,
              expirationDate: typeof values.expirationDate === 'string' ? onlyNumbers(values.expirationDate) : '',
              amount: fromCadastro === true ? valor_selecionado * 100 : valor * 100,
              // tipoCartao: tipoCartao,
              holder_name: values.name,
              holder_document: typeof values.cpf === 'string' ? onlyNumbers(values.cpf) : '',
              frequencia: state.frequencia,
              valorParcelas: valorParcelas,
              split_rules:
                tipo_voucher === 'Vendedor'
                  ? voucher
                    ? voucher.recipient_id_vindi_gerente
                      ? [
                          { amount: mdvGerente, affiliate_id: parseInt(voucher.recipient_id_vindi_gerente), amount_type: 'percentage' },
                          { amount: mdvDiretor, affiliate_id: parseInt(voucher.recipient_id_vindi_diretor), amount_type: 'percentage' },
                          { amount: mdvPercent, affiliate_id: parseInt(voucher.recipient_id_vindi), amount_type: 'percentage' },
                          ...(split_jj ? [split_jj] : []),
                        ]
                      : voucher.recipient_id_vindi_diretor
                        ? [
                            { amount: mdvDiretor, affiliate_id: parseInt(voucher.recipient_id_vindi_diretor), amount_type: 'percentage' },
                            { amount: mdvPercent, affiliate_id: parseInt(voucher.recipient_id_vindi), amount_type: 'percentage' },
                            { amount: 100 - mdvPercent - mdvDiretor, affiliate_id: VINDI_AFFILIATE_DEOVITA_ID, amount_type: 'percentage' },
                          ]
                        : [
                            { amount: mdvPercent, affiliate_id: parseInt(voucher.recipient_id_vindi), amount_type: 'percentage' },
                            { amount: 100 - mdvPercent, affiliate_id: VINDI_AFFILIATE_DEOVITA_ID, amount_type: 'percentage' },
                          ]
                    : split
                  : split,
              installments: parcel,
              forma_pgto: 'card',
              triagem: state?.triagem ? state?.triagem : false,
              paid: false,
              item: fromCadastro
                ? {
                    client_id: state.client_id,
                    nome: state.name,
                    fone: user.phone1 ? user.phone1 : state.phone,
                    adicionais: state.adicionais,
                    plano: state.id_plano,
                  }
                : state.item,
              voucher: tipo_voucher === 'Vendedor' ? voucher : null,
              otherVoucher: tipo_voucher === 'Vendedor' ? null : voucher,
            };
          }
          const vals = { ...val };
          if (!usuarioAssinante && fromCadastro) {
            vals.split_rules = vals?.split_rules ? (vals.split_rules || []).filter((obj) => Object.keys(obj).length > 0) : '';
          }
          setLoading(true);
          setAviso(null);
          console.log(vals);  
          pagar(vals);
        }}
      >
        {({ errors, touched, isValid, dirty }) => {
          return (
            <Box as={Form} pb={10} borderRadius={'0.8em'}>
              <Box alignItems="center" overflowX="auto" whiteSpace="nowrap" px={0} mt={1}>
                {arrayCards.map((card, index) => {
                  return (
                    <Box
                      key={index}
                      position="relative"
                      display="inline-block"
                      borderRadius="1em"
                      minW="180px"
                      maxW="220px"
                      mr={4}
                      p={4}
                      mb="1em"
                      h="130px"
                      overflow="hidden"
                      boxShadow="md"
                      bg={index === cartaoSelecionado ? 'linear-gradient(108.08deg, #E1F1F1 0%, #B5DDDC 100%)' : 'white'}
                      transition="all 0.2s ease"
                      cursor="pointer"
                      onClick={() => {
                        setCartaoSelecionado(index);
                        handleClickCard(arrayCards[index]);
                      }}
                    >
                      <Flex direction="column" h="100%" justify="space-between">
                        <Flex direction="column" gap={2}>
                          <Cards color={themeApp?.background} />
                          <Text color="#585858" fontSize="sm" fontWeight="medium">
                            {card.brand}
                          </Text>
                        </Flex>

                        <Flex align="center" justify="space-between">
                          <Text color="#757575" fontSize="sm">
                            •••• {card.last_digits}
                          </Text>

                          {card.default === true && (
                            <Text
                              fontSize="xs"
                              fontWeight="bold"
                              color="#5AB2AE"
                              bg={`linear-gradient(108.08deg, #E1F1F1 0%, #B5DDDC 100%) 15`}
                              px={3}
                              py={1}
                              borderRadius="full"
                            >
                              Principal
                            </Text>
                          )}
                        </Flex>
                      </Flex>
                    </Box>
                  );
                })}
              </Box>

              {aviso && (
                <Box bg="red.50" border="1px solid" borderColor="red.200" borderRadius="lg" p={4} mb={3}>
                  <HStack align="flex-start" spacing={3}>
                    <Box color="red.400" flexShrink={0} pt="2px">
                      <FaCircleExclamation size={18} />
                    </Box>
                    <Box>
                      <Text color="red.700" fontSize="sm" fontWeight="bold" mb={1}>
                        Pagamento não realizado
                      </Text>
                      <Text color="red.600" fontSize="sm">
                        {aviso}
                      </Text>
                      <Text color="red.400" fontSize="xs" mt={1}>
                        Tente com outro cartão ou entre em contato com seu banco.
                      </Text>
                    </Box>
                  </HStack>
                </Box>
              )}

              {permiteParcelamento && (
                <SelectField
                  name="parcel"
                  borderColor={backgroundColor}
                  color={backgroundColor}
                  variant="outline"
                  onChange={(e) => {
                    setParcel(parseInt(e) + 1);
                  }}
                  w="100%"
                  isDisabled={!parcelsActive}
                  options={arrayTextoParcelas}
                  value={state.service === 'contract' && state.parcelsActive ? 11 : 0}
                />
              )}

              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                mt={2}
                mb={2}
                bg="linear-gradient(90deg, #E1F1F1 0%, #FFFFFF 100%)"
                borderRadius="1em"
                p={2}
              >
                <Box display="flex" alignItems="center" gap={3}>
                  <Box display="flex" alignItems="center" justifyContent="center" bg="#E0E0E0" borderRadius="full" p={2}>
                    <GiPadlock size={22} color="#5AB2AE" />
                  </Box>
                  <Box>
                    <Text color="#616161" fontWeight="bold">
                      Pagamento 100% Seguro
                    </Text>
                    <Text color="#5AB2AE">Seus dados estão protegidos.</Text>
                  </Box>
                </Box>
              </Box>

              <Box w="100%" border="1px solid #EDEDED" borderRadius="lg" p={4} my={2} bg="white" boxShadow="xs">
                <Text fontSize="sm" fontWeight="bold" color="#424242" mb={2}>
                  Resumo do Pedido
                </Text>

                <HStack justify="space-between" align="flex-start" mb={1}>
                  <Box>
                    <Text fontSize="sm" color="#616161" fontWeight="semibold">
                      {state.frequenciaText}
                    </Text>
                    {state?.service === 'contract' && (
                      <>
                        <Text
                          display="inline-block"
                          textAlign="center"
                          fontSize="0.7em"
                          color="#616161"
                          fontWeight="semibold"
                          bg="#EEEEEE"
                          px={2}
                          py={1}
                          borderRadius={5}
                          mt={1}
                        >
                          {state?.plano_anual ? 'Anual' : 'Mensal'}
                        </Text>
                      </>
                    )}
                  </Box>

                  <Text fontSize="sm" fontWeight="bold" color="#424242">
                    {valor_original_formatado}
                  </Text>
                </HStack>

                {!usuarioAssinante && state?.valor_assinante && (
                  <HStack justify="space-between" mb={2}>
                    <HStack spacing={2} align="center" justify="center">
                      <Text fontSize="xs" color="#616161" fontWeight="semibold">
                        Assine e economize!
                      </Text>
                      <Image src={Clube} alt="Clube de Vantagens" h={3} />
                    </HStack>
                    <Text fontSize="xs" fontWeight="bold" color="#2A918A">
                      {Number(state.valor_assinante).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </Text>
                  </HStack>
                )}

                {voucherConsulta()}

                <Divider my={2} />

                <HStack justify="space-between">
                  <Text fontSize="sm" fontWeight="bold" color="#424242">
                    Valor total:
                  </Text>

                  <Text fontSize="sm" fontWeight="bold" color="#2A918A">
                    {Number(!usuarioAssinante && state?.valor_com_desconto ? state.valor_com_desconto : valor_selecionado).toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </Text>
                </HStack>
              </Box>

              {arrayCards?.length >= 1 ? (
                <ButtonGroup width="100%" mt={arrayCards?.length < 1 ? '' : 4}>
                  {state.service !== 'contract' && ((user.titular === true && !user?.id_contrato) || (!user.titular && !user?.id_plano)) ? (
                    <>
                      <Box width="100%" alignItems="center">
                        <Button
                          backgroundColor="#EEEEEE"
                          color="#424242"
                          type="submit"
                          w="100%"
                          fontSize="sm"
                          isLoading={loading}
                          loadingText="Carregando"
                          mt={4}
                          borderRadius={'full'}
                          disabled={fromCadastro && !(user.loggedIn && cards?.length > 0) ? !(isValid && dirty) : !data.cardNumber}
                        >
                          Continuar sem economizar
                        </Button>

                        <Button
                          backgroundColor={backgroundColor}
                          color="#FFF"
                          w="100%"
                          fontSize="sm"
                          isLoading={loading}
                          loadingText="Carregando"
                          borderRadius={'full'}
                          mt={4}
                          disabled={fromCadastro && !(user.loggedIn && cards?.length > 0) ? !(isValid && dirty) : !data.cardNumber}
                          type="button"
                          onClick={() => {
                            navigate('/cadastro/plano');
                          }}
                        >
                          Assine e economize
                        </Button>
                      </Box>
                    </>
                  ) : (
                    <>
                      <Button
                        backgroundColor={backgroundColor}
                        color="#FFF"
                        type="submit"
                        w="100%"
                        isLoading={loading}
                        loadingText="Carregando"
                        mt={4}
                        disabled={!data.cardNumber}
                        borderRadius={'full'}
                      >
                        Realizar pagamento
                      </Button>
                    </>
                  )}
                </ButtonGroup>
              ) : (
                <>
                  <Button
                    backgroundColor={backgroundColor}
                    color="#FFF"
                    w="100%"
                    mt={4}
                    rightIcon={<FaCreditCard />}
                    onClick={() => {
                      navigate('/perfil/pagamento/cadastro-cartao', { state: { themeApp, voltar: true } });
                    }}
                    borderRadius={'full'}
                  >
                    Cadastrar cartão
                  </Button>
                </>
              )}
            </Box>
          );
        }}
      </Formik>
      {paid && (
        <Modal isOpen={true} isCentered>
          <ModalOverlay />
          <ModalContent p={8} bgColor="#F3F3F3" borderRadius={10} color="#585858" m={4}>
            <CheckCircle width={25} height={25} />
            <Text mt={4} fontWeight="bold" fontSize={20}>
              Seu <span style={{ color: '#5AB2AE' }}>pagamento</span> foi realizado <span style={{ color: '#5AB2AE' }}>com sucesso!</span>
            </Text>
            <Text mt={4} fontSize="sm" color="#9E9E9E">
              Você será redirecionado automaticamente...
            </Text>
            <Button isFullWidth colorScheme="teal" onClick={goNext} mt={6}>
              Continuar agora
            </Button>
          </ModalContent>
        </Modal>
      )}
      {awaitingWebhook && (
        <Modal isOpen={true} isCentered>
          <ModalOverlay />
          <ModalContent p={8} bgColor="#F3F3F3" borderRadius={10} color="#585858" m={4}>
            <Center flexDirection="column" gap={4}>
              <Spinner thickness="4px" emptyColor="gray.200" color="#5AB2AD" size="xl" speed="1s" />
              <Text fontWeight="bold" fontSize={16} textAlign="center">
                Confirmando pagamento...
              </Text>
              <Text fontSize="sm" color="#9E9E9E" textAlign="center">
                Aguarde enquanto processamos seu cartão.
              </Text>
            </Center>
          </ModalContent>
        </Modal>
      )}
      <VindiSupportBubble />
      <Modal onClose={onClose} isOpen={loading} isCentered>
        <ModalOverlay />
        <ModalContent bg={'transparent'}>
          <ModalBody>
            <Center p={8} w={'100%'} bg="#F3F3F3" flexDirection={'column'} gap={10} rounded={10}>
              <Spinner thickness="4px" emptyColor="gray.200" color="#5AB2AD" size="xl" speed="1s" />
              <Text>
                Estamos carregando as <br />
                informações, aguarde...
              </Text>
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default CartaoGenerico;
